import React from 'react';
import { Hero } from '../components/home/Hero';
import { UspStrip } from '../components/home/UspStrip';
import { CategoryGrid } from '../components/home/CategoryGrid';
import { BestSellers } from '../components/home/BestSellers';
import { BatteryAdvisor } from '../components/home/BatteryAdvisor';
import { BrandStrip } from '../components/home/BrandStrip';
export function Home() {
  return <>
      <Hero data-id="element-668" data-mp="1ziqvdplqi0ms" />
      <UspStrip data-id="element-669" data-mp="1zj8zf8en1j59" />
      <CategoryGrid data-id="element-670" data-mp="1zjii0axcso0x" />
      <BestSellers data-id="element-671" data-mp="1zkaahcvnm5mz" />
      <BatteryAdvisor data-id="element-672" data-mp="24gsay0jybhti" />
      <BrandStrip data-id="element-673" data-mp="24g8wwuxf9dkr" />
    </>;
}